export default __webpack_public_path__ + "static/media/Scarlet Fighters Ring.22ea250f.jpg";